
<template>
   <el-dialog width="50%" title="已应招师傅信息" :visible.sync="workerflag" append-to-body>
       <div style="height:300px;" v-if="works.length>0">
            <div v-for="item in works" :key="item.name" style="width:60px;float:left;margin-right:15px;">
                <img :src="item.avatar?getimgpath(item.avatar):item.headimgurl" style="width:60px;height:60px;border-radius: 50%;">
                <el-tag>{{item.name}}</el-tag>
            </div>
       </div>
       <div v-else style="text-align: center;font-size: 17px;">
           <span>暂无应招师傅,请到微信小程序中邀请师傅或等待师傅接活.</span>
       </div>
    </el-dialog>
</template>
<script>
import {getImgLink} from '@/config/env'
    export default {
        data() {
            return {
                workerflag : false,
                works : []
            }
        },
        methods: {
            workerstate(data){
                this.works = data;
                this.workerflag = true;
            },
            //展示图片信息
            getimgpath(data){
                return getImgLink(data);
            }
        }
    }
</script>